// extracted by mini-css-extract-plugin
export default {"pagination":"procedure-tables-training_pagination__ZqKzE"};